import { useEffect } from 'react';
import { createScriptTags } from './../utilities/helpers';

const useAddScriptTags = scriptOptions => {
    
    useEffect(() => {
        createScriptTags(scriptOptions);
    }, [scriptOptions]);

    return null;
}

export default useAddScriptTags;